/**
 * Returns the bundled pdfjs worker URL.
 *
 * Webpack 5 resolves the `new URL(..., import.meta.url)` pattern at build time
 * and emits the worker as a separate asset.  This module isolates that syntax
 * so it can be mocked in Jest (which cannot parse `import.meta`).
 */
export function getPdfjsWorkerSrc(): string {
  return new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString();
}
